import { Box, Link, Typography, useTheme } from '@mui/material';

export const FOOTER_HEIGHT = '60px';

export function Footer({ showFooter = false }: { showFooter?: boolean }) {
  const theme = useTheme();

  const COPYRIGHT_YEAR = new Date().getFullYear();

  if (!showFooter) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        px: theme.spacing(6),
        height: FOOTER_HEIGHT,
      }}
      data-testid="appFooter"
    >
      <Box
        sx={{
          borderTop: `1px solid ${theme.palette.divider}`,
          py: theme.spacing(4),
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            gap: theme.spacing(6),
          }}
        >
          <Box>
            <Link
              data-testid="contact-us"
              href="https://verantos.com/contact-us"
              target="_blank"
              rel="noreferrer"
              underline="none"
              typography={'body1'}
              sx={{ whiteSpace: 'nowrap' }}
            >
              Contact us
            </Link>
          </Box>
          <Box>
            <Link
              data-testid="privacy-policy"
              href="https://verantos.com/privacy-policy"
              target="_blank"
              rel="noreferrer"
              underline="none"
              typography={'body1'}
              sx={{ whiteSpace: 'nowrap' }}
            >
              Privacy policy
            </Link>
          </Box>
          <Box>
            <Link
              data-testid="verantosdotcom"
              href="https://verantos.com"
              target="_blank"
              rel="noreferrer"
              underline="none"
              typography={'body1'}
              sx={{ whiteSpace: 'nowrap' }}
            >
              <Box whiteSpace={'nowrap'}>Verantos.com</Box>
            </Link>
          </Box>
        </Box>

        <Box
          sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width: '100%' }}
        >
          <Box>
            <Typography
              data-testid="copyrightValue"
              variant="body1"
            >{`Copyright \u00a9 ${COPYRIGHT_YEAR} Verantos`}</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
